require('./brokerAdvancedSearchResultList.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const { BrokerAdvancedSearchResult } = require('components/broker/brokerAdvancedSearchResult/brokerAdvancedSearchResult');
const { ContentBox } = require('commonsComponents/contentBox');
const complexityIcon = require('assets/icons/complexity_icon.svg');

// @commons
const { OKLink } = require('commonsComponents/OKLink');

// @constants
const {
    BROKER_PRODUCT_ADVANCED_SEARCH_MORE_RESULTS,
    TYPE_WARRANTS,
    TYPE_STOCKS,
    TYPE_PLANS,
    ALTERNATIVE_FUNDS,
    TYPE_CRYPTO,
    MYPROFILE_BROKER_EXPLORE_RESULTS_URL,
} = require('constants/index');

import { WEALTH_CRYPTO } from 'constants/flagBasedMBFeatures';


class BrokerAdvancedSearchResultList extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const customData = {
            nombrePagina: 'broker/buscador-avanzado',
        };
        window && window.utag && window.utag.view && window.utag.view(customData)
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.immBrokerProductAdvancedSearch.get('isFetching');
    }

    searchSpecificProduct(product, type) {
        this.props.searchSpecificProduct(product);
        this.props.searchSpecificProductTracking(type);
    }

    buildAllResultsProductLink(type, isOnlyOneProduct, totalProduct) {
        const { stopViewMoreRedirections } = this.props;

        if(!isOnlyOneProduct && totalProduct > BROKER_PRODUCT_ADVANCED_SEARCH_MORE_RESULTS) {
            const headerLink = `brokerSearchWidget-brokerSearchWidget_${type}ViewAllLink`;
            const advancedSearchUrl = stopViewMoreRedirections ? '' : `${MYPROFILE_BROKER_EXPLORE_RESULTS_URL}/${type}`;
            const product = type.toUpperCase();

            return (
                <OKLink
                    extraClass="broker-advanced-search-result-list__footer-link"
                    to={advancedSearchUrl}
                    onClick={() => {this.searchSpecificProduct(product, type)}}
                    modifier="widget">
                    {formatText(headerLink)}
                </OKLink>
            );
        }
    }

    buildHeaderDisclaimer(type) {
        const { immFlagBasedFeatures } = this.props;
        let content;
        switch (type) {
            case TYPE_STOCKS:
                content =  immFlagBasedFeatures.get('landing_risk_indicator')
                    ? (
                        <div className="broker-advanced-search-result-list__stocks-risk-box">
                            <div className="broker-advanced-search-result-list__stocks-risk-box-risk">
                                <span className="broker-advanced-search-result-list__stocks-risk-box-risk-value">6</span>/6
                            </div>
                            <div className="broker-advanced-search-result-list__stocks-risk-box-details">
                                <FormattedText value="preContractInfo-riskBox1" />
                            </div>
                        </div>
                    ) : null;
                break;
            case TYPE_PLANS:
                content = (
                    <div className="broker-advanced-search-result-list__plans-header-box">
                        <p className="broker-advanced-search-result-list__plans-header-box-title">
                            <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_plansDisclaimerTitle" />
                        </p>
                        <div className="broker-advanced-search-result-list__plans-header-box-content">
                            <div className="broker-advanced-search-result-list__plans-header-box-content-icons">
                                <i className="icon-candado"/>
                                <i className="icon-candado"/>
                            </div>
                            <div className="broker-advanced-search-result-list__plans-header-box-content-text">
                                <p>
                                    <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_plansDisclaimerContent1" />
                                </p>
                            </div>
                        </div>
                        <div className="broker-advanced-search-result-list__plans-header-box-content">
                            <div className="broker-advanced-search-result-list__plans-header-box-content-icons">
                                <i className="icon-candado"/>
                                <i className="icon-candado"/>
                            </div>
                            <div className="broker-advanced-search-result-list__plans-header-box-content-text">
                                <p>
                                    <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_plansDisclaimerContent2" />
                                </p>
                            </div>
                        </div>
                    </div>
                );
                break;
                case ALTERNATIVE_FUNDS:
                    content = (
                        <div className="broker-advanced-search-result-list__plans-header-box">
                            <p className="broker-advanced-search-result-list__plans-header-box-title">
                                <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_alternativeFundsDisclaimerTitle1" />
                            </p>
                            <div className="broker-advanced-search-result-list__plans-header-box-content">
                                <div className="broker-advanced-search-result-list__plans-header-box-content-icons">
                                    <img
                                        className="broker-advanced-search-result-list__warrants-header-box-content-complexity-icon"
                                        src={complexityIcon}
                                        alt="complexity icon"
                                    />
                                </div>
                                <div className="broker-advanced-search-result-list__plans-header-box-content-text">
                                    <p>
                                        <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_alternativeFundsDisclaimerContent1" />
                                    </p>
                                </div>
                            </div>
                            <p className="broker-advanced-search-result-list__plans-header-box-title">
                                <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_alternativeFundsDisclaimerTitle2" />
                            </p>
                            <div className="broker-advanced-search-result-list__plans-header-box-content">
                                <div className="broker-advanced-search-result-list__plans-header-box-content-icons">
                                    <i className="icon-candado"/>
                                    <i className="icon-candado"/>
                                </div>
                                <div className="broker-advanced-search-result-list__plans-header-box-content-text">
                                    <p>
                                        <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_alternativeFundsDisclaimerContent2" />
                                    </p>
                                </div>
                            </div>
                            <div className="broker-advanced-search-result-list__plans-header-box-content">
                                <div className="broker-advanced-search-result-list__plans-header-box-content-icons">
                                    <i className="icon-candado"/>
                                    <i className="icon-candado"/>
                                </div>
                                <div className="broker-advanced-search-result-list__plans-header-box-content-text">
                                    <p>
                                        <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_alternativeFundsDisclaimerContent3" />
                                    </p>
                                </div>
                            </div>
                        </div>
                    );
                    break;
            case TYPE_WARRANTS:
                content = (
                    <div className="broker-advanced-search-result-list__warrants-header-box">
                        <p className="broker-advanced-search-result-list__warrants-header-box-title">
                            <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_warrantDisclaimerTitle" />
                        </p>
                        <div className="broker-advanced-search-result-list__warrants-header-box-content">
                            <div className="broker-advanced-search-result-list__warrants-header-box-content-icon">
                                <img
                                    className="broker-advanced-search-result-list__warrants-header-box-content-complexity-icon"
                                    src={complexityIcon}
                                    alt="complexity icon"
                                />
                            </div>
                            <div className="broker-advanced-search-result-list__warrants-header-box-content-text">
                                <p>
                                    <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_warrantDisclaimerContent" />
                                </p>
                            </div>
                        </div>
                    </div>
                );
                break;
            default:
                content = null;
                break;
        }
        return content;
    }


    buildResultsList(type, list) {
        const {
            addProductToList,
            deleteProductFromList,
            immBrokerProductAdvancedSearch,
            hasNoStockContracts,
            showSelectButton,
            handleClickSelectButton,
            watchlistEnabled,
            watchlistTutorialHasBeenShown
        } = this.props;
        const instrumentsList = list.get('instrumentsList', []);

        if (instrumentsList.size) {
            const isOnlyOneProduct = immBrokerProductAdvancedSearch.get('isOnlyOneProduct');
            const headerTitle = isOnlyOneProduct ? `brokerAdvancedSearch-brokerAdvancedSearch_${type}AllResultsTitle` : `brokerSearchWidget-brokerSearchWidget_${type}HeaderTitle`
            const pageNumber = immBrokerProductAdvancedSearch.get('pageNumberFormatted');
            const totalPages = immBrokerProductAdvancedSearch.getIn(['results', type, 'totalPagesFormatted']);
            const subtitle = isOnlyOneProduct ? (
                <React.Fragment>
                    <br/>
                    <FormattedText
                        className="broker-advanced-search-result-list__header-subtitle"
                        value={"brokerAdvancedSearch-brokerAdvancedSearch_headerSubtitle"}
                        injectedStrings={[pageNumber, totalPages]}
                    />
                </React.Fragment>
            ) : null;
            const header = (
                <div>
                    <div className="broker-advanced-search-result-list__header">
                        <FormattedText className="broker-advanced-search-result-list__header-title" value={headerTitle} />
                        {subtitle}
                    </div>
                </div>
            );

            const listStyle = classNames(
                `broker-advanced-search-result-list`,
                `broker-advanced-search-result-list--${type}`
            );
            const resultList = instrumentsList.map((instrument, key) => {
                return (
                    <div className={listStyle} key={"broker-advanced-search-result" + key}>
                        <BrokerAdvancedSearchResult
                            result={instrument}
                            type={type}
                            rowIndex={key}
                            addProductToList={addProductToList}
                            deleteProductFromList={deleteProductFromList}
                            hasNoStockContracts={hasNoStockContracts}
                            showSelectButton={showSelectButton}
                            handleClickSelectButton={handleClickSelectButton}
                            watchlistEnabled={watchlistEnabled}
                            watchlistTutorialHasBeenShown={watchlistTutorialHasBeenShown}
                        />
                    </div>
                );
            })
            const totalProduct = list.get('total');
            const footerLink = this.buildAllResultsProductLink(type, isOnlyOneProduct, totalProduct);
            const headerDisclaimer = this.buildHeaderDisclaimer(type);
            return (
                <ContentBox
                    id="broker-advanced-search-result-list"
                    key={"broker-advanced-search-result-list-"+type}
                    title={header}
                    smallTitle={true}
                    customClassName="broker-advanced-search-result-list"
                    modifier="v"
                    product="wealth"
                    footerContent={footerLink}
                >
                    {headerDisclaimer}
                    {resultList}
                </ContentBox>
            );
        }

        return null;
    }

    render() {
        const { immBrokerProductAdvancedSearch, immFlagBasedMBFeatures } = this.props;
        let results = immBrokerProductAdvancedSearch.get('results');
        const searchEmpty = immBrokerProductAdvancedSearch.get('searchEmpty');
        const shouldShowCrypto = immFlagBasedMBFeatures.get(WEALTH_CRYPTO);
        
        
        if (!shouldShowCrypto) {
            results = results.delete(TYPE_CRYPTO);
        };

        if (!searchEmpty) {
            const buildResultList = [];

            results.forEach((item, key) => {
                buildResultList.push(this.buildResultsList(key, item));
            });

            return (
                <React.Fragment>
                    {buildResultList}
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
}

BrokerAdvancedSearchResultList.propTypes = {
    addProductToList: PropTypes.func.isRequired,
    deleteProductFromList: PropTypes.func.isRequired,
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.immFlagBasedFeatures,
    immFlagBasedMBFeatures: PropTypes.object.isRequired,  
    hasNoStockContracts: PropTypes.bool,
    searchSpecificProduct: PropTypes.func.isRequired,
    searchSpecificProductTracking: PropTypes.func,
    stopViewMoreRedirections: PropTypes.bool,
    showSelectButton: PropTypes.bool,
    handleClickSelectButton: PropTypes.func,
    watchlistEnabled: PropTypes.bool,
    watchlistTutorialHasBeenShown: PropTypes.bool
};

module.exports = BrokerAdvancedSearchResultList;
